//表演场地相关的请求
import { request } from "@/utils";

export function uploadShowLocationAPI(showLocation) {
  return request({
    url: '/show-location-entity/add-place',
    method: 'POST',
    data: showLocation
  })
}

export function checkShowLocationAPI(showLocationName) {
  return request({
    url: `/show-location-entity/check-place-exist?showLocationName=${showLocationName}`,
    method: 'POST',
  })
}

export function updateShowLocationAPI(showLocation) {
  return request({
    url: '/show-location-entity/update-place',
    method: 'POST',
    data: showLocation
  })
}

export function getShowLocationListAPI() {
  return request({
    url: '/show-location-entity/get-place-coordinates-list-by-visible',
    method: 'GET',
  })
}

export function getShowLocationListByUserIdAPI(userId) {
  return request({
    url: `/show-location-entity/get-place-list-by-userId?userId=${userId}`,
    method: 'POST',
  })
}

export function getShowLocationAPI(id) {
  return request({
    url: `/show-location-entity/get-place-by-id?id=${id}`,
    method: 'POST',
  })
}

// 获取包含坐标区域的详情（新接口）
export function getShowLocationCoordinatesByIdAPI(id) {
  return request({
    url: `/show-location-entity/get-place-coordinates-by-id?id=${id}`,
    method: 'POST'
  })
}

export function getShowLocationByNameAPI(name) {
  return request({
    url: `/show-location-entity/get-place-by-name?name=${name}`,
    method: 'POST',
  })
}

export function getSelectedPhotoAPI(id, count) {
  return request({
    url: `/show-location-entity/get-photo-by-id?id=${id}&count=${count}`,
    method: 'POST',
  })
}

export function setShowLocationVisibleAPI(id, visible) {
  return request({
    url: `/show-location-entity/set-showLocation-visible?showLocationId=${id}&visible=${visible}`,
    method: 'POST'
  })
}